import { render, staticRenderFns } from "./ProfileRecordCard.vue?vue&type=template&id=0dcb3e92&"
import script from "./ProfileRecordCard.vue?vue&type=script&lang=js&"
export * from "./ProfileRecordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports